export default {
  computed: {
    stateCity: {
      get: function () {
        if (this.address.administrative_area_level_1 && this.address.locality) {
          return (
            this.address.administrative_area_level_1 +
            "/" +
            this.address.locality
          );
        } else if (this.address.administrative_area_level_1) {
          return this.address.administrative_area_level_1;
        } else if (this.address.locality) {
          return this.address.locality;
        } else {
          return "";
        }
      },
      set: function (newValue) {
        var names = newValue.split("/");
        if (names.length == 1) {
          this.address.administrative_area_level_1 = newValue;
        } else if (names.length == 2) {
          this.address.administrative_area_level_1 = names[0];
          this, (this.address.administrative_area_level_1 = names[1]);
        }
      }
    }
  },

  methods: {
    getAddressData(addressData, placeResultData) {
      let componentForm = {
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "short_name",
        country: "long_name",
        postal_code: "short_name"
      };
      for (var i = 0; i < placeResultData.address_components.length; i++) {
        var addressType = placeResultData.address_components[i].types[0];
        if (componentForm[addressType]) {
          var val =
            placeResultData.address_components[i][componentForm[addressType]];
          this.address[addressType] = val;
        }
      }
    },
    validate() {
      return this.$validator.validateAll()
    },
    validateAddress() {
      return this.$refs.deliveryAddress.validate();
    },
    handleError(error) {
      alert(error);
    },
    setStreetAddress() {
      this.editModel.StreetAddress = this.$refs.gAutoComplete.$el.value;
    }
  }
};
